import React, { useEffect, useState } from "react";
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Images from "./images";
import { sociallistApi } from "./API/cms.api";


function Footer() {
    const [social, SetSocial] = useState(null);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const fetchSocial = async () => {
            const socail = await sociallistApi()
            console.log("🚀 ~ fetchSocial ~ socail:", socail)
            if (socail.status) SetSocial(socail.data);

        }


        fetchSocial()

    }, [])

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    return (

        <>
            <div className={`${scrolled ? "footerSection footerscrolled" : ""}`}>
                <img src={Images.footertopimg} className="img-fluid footertopimg w-100" width="1637px" height="31px" alt="galfi_footerlogo" />
                {/* <Row className="align-items-center text-center text-lg-start pb-3">
                <Col md={12} lg={3} xl={3} xxl={3} className="mt-3 mt-lg-0">
                    <img src={Images.logo} className="img-fluid logos footlogo" alt="galfi_footerlogo" width="400px" height="60px" />
                </Col>
                <Col md={12} lg={5} xl={5} xxl={4} className="mt-3 mt-lg-0">
                    <p className="text-white copyright mb-0">Copyright @ 2024 Galfi. All Rights Reserved</p>
                </Col>
                <Col md={12} lg={4} xl={4} xxl={5} className="socialmedia justify-content-center justify-content-lg-end pe-4 mt-3 mt-lg-0">
                    <Link to={social?.medium} target="_blank" aria-label="socialmedium"> <img src={Images.social1} className="img-fluid mediumicon socialicon" width="70px" height="70px" alt="medium" /></Link>
                    <Link to={social?.discord} target="_blank" aria-label="socialdiscord"> <img src={Images.social2} className="img-fluid socialicon" width="70px" height="70px" alt="discord" /></Link>
                    <Link to={social?.telegram} target="_blank" aria-label="socialtelegram"> <img src={Images.social3} className="img-fluid socialicon" width="70px" height="70px" alt="telegram" /></Link>
                    <Link to={social?.twitter} target="_blank" aria-label="socialtwitter"> <img src={Images.social4} className="img-fluid twiticon socialicon" width="70px" height="70px" alt="twitter" /></Link>
                </Col>
            </Row> */}
                <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-sm-between mb-3">
                    <div className="d-flex align-items-center gap-3">
                        <div>
                            <img src={Images.logo} className="img-fluid logos footlogo" alt="galfi_footerlogo" width="400px" height="60px" />
                        </div>
                        <div>
                            {/* <p className="text-white copyright mb-0">Copyright @ 2024 Galfi. All Rights Reserved</p> */}
                            <p className="text-white copyright mb-0">© 2024 GalFi</p>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <Link to={social?.discord} target="_blank" aria-label="socialdiscord"> <img src={Images.social2} className="img-fluid socialicon" width="25px" height="25px" alt="discord" /></Link>
                        <Link to={social?.twitter} target="_blank" aria-label="socialtwitter"> <img src={Images.social4} className="img-fluid twiticon socialicon" width="25px" height="25px" alt="twitter" /></Link>
                        <Link to={social?.telegram} target="_blank" aria-label="socialtelegram"> <img src={Images.social3} className="img-fluid socialicon" width="25px" height="25px" alt="telegram" /></Link>
                        <Link to={social?.medium} target="_blank" aria-label="socialmedium"> <img src={Images.social1} className="img-fluid mediumicon socialicon" width="25px" height="25px" alt="medium" /></Link>
                        <Link to="https://www.youtube.com/watch?v=f7xSCWQ6Uck" target="_blank" aria-label="socialmedium"> <img src={Images.youtubes} className="img-fluid mediumicon socialicon" width="25px" height="25px" alt="medium" /></Link>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Footer;